/**
 * @module ConstructorIO/search
 */

import progress from '../../utils/progress';
import {reInitSections, reInitTiles, startLoading} from '../../pages/search-results/helper';
import {loadMoreProducts, updateProductGrid, updateRefinementSelection} from '../helpers/search';
import {init as initFilters2019} from '../../filters2019/main';

/**
 * @param {import('.').default} constructorIOSearch - Constructor.io search wrapper
 * @param {string} clearURL - url clear of refinements
 * @returns {number} number of products
 */
export const handleClearAllRefinements = async (constructorIOSearch, clearURL) => {
    progress.show('.search-result-content');
    window.history.pushState(window.history.state, document.title, clearURL);
    const result = await updateProductGrid(constructorIOSearch);
    if (result) {
        reInitSections();
    }
    progress.hide();
    return result;
};

/**
 * @param {import('.').default} constructorIOSearch - Constructor.io search wrapper
 * @param {HTMLElement} loadMoreBtn - element interacted with
 * @returns {Promise<void>}
 */
export const handleLoadMore = async (constructorIOSearch, loadMoreBtn) => {
    startLoading();
    const result = await loadMoreProducts(constructorIOSearch, loadMoreBtn);
    if (result) {
        reInitTiles();
    }
};

/**
 * @param {import('.').default} constructorIOSearch - Constructor.io search wrapper
 * @param {HTMLElement} [applyButton] - the apply filters button if clicked
 * @param {Object} [additionalFilters] - additional filters
 * @param {string} [refineURL] - refine url
 * @returns {number} number of products
 */
export const handleRefinements = async (constructorIOSearch, applyButton, additionalFilters, refineURL) => {
    progress.show('.search-result-content');
    const result = await updateProductGrid(constructorIOSearch, applyButton, additionalFilters, refineURL);
    if (result) {
        reInitSections();
    }
    progress.hide();
    return result;
};

/**
 * @param {import('.').default} constructorIOSearch - Constructor.io search wrapper
 * @param {HTMLOptionElement} [selectedOption] - optionally the selected element
 */
export const handleSort = async (constructorIOSearch, selectedOption) => {
    const selectedSortOption = selectedOption || document.querySelector('#dropdown__selected');
    if (selectedSortOption) {
        const {sortId, value} = selectedSortOption.dataset;
        const nextPageURL = new URL(window.location.href);
        const {searchParams} = nextPageURL;
        searchParams.set('sort_by', sortId);
        searchParams.set('sort_order', value);
        searchParams.delete('page');
        window.history.pushState(window.history.state, document.title, nextPageURL.toString());
    }
    await handleRefinements(constructorIOSearch);
};

/**
 * Used for mobile refinements where the filters can be selected without being applied.
 *
 * @param {import('.').default} constructorIOSearch - Constructor.io search wrapper
 * @param {HTMLAnchorElement} [clickedFilter] - optionally clicked refinement to extract data from
 * @param {Object} [filters] - optional filters to include in the search
 * @param {string} [cancelURL] - url when resetting the refinements panel
 * @returns {number} number of products
 */
export const handleNonInstantRefinementSelection = async (constructorIOSearch, clickedFilter, filters, cancelURL) => {
    const result = await updateRefinementSelection(constructorIOSearch, clickedFilter, filters, cancelURL);
    if (result) {
        initFilters2019();
    }
    return result;
};
